<template>
    <div>
        <div class="elasticComputeCloudResource-title">
            <div>EC2</div>
            <div>
                <Button type="primary" :loading="modal_loading" @click="exportList" v-hasPermission="['resourceConfigurationManagement:aws:reservedInstanceResource:ec2:export']">{{ $t('common.export') }}</Button>
            </div>
        </div>
        <div class="elasticComputeCloudResource-top">
            <elastic-compute-cloud-resource-search ref="elasticComputeCloudResourceSearchChild"></elastic-compute-cloud-resource-search>
        </div>
        <table-elastic-compute-cloud-resource></table-elastic-compute-cloud-resource>
    </div>
</template>

<script>
    import ElasticComputeCloudResourceSearch from '../ec2/ElasticComputeCloudResourceSearch'
    import TableElasticComputeCloudResource from '../ec2/TableElasticComputeCloudResource'

    export default {
        name: 'ElasticComputeCloudResource',
        components: {
            ElasticComputeCloudResourceSearch,
            TableElasticComputeCloudResource
        },
        data () {
            return {
                modal_loading: false,
                accountIds: [],
                regions: [],
                offeringType: '',
                awsId: '',
                expiration: '',
                state: ''
            }
        },
        methods: {
            //导出
            exportList: function () {
                // 获取子组件数据
                this.awsId = this.$refs.elasticComputeCloudResourceSearchChild.awsId;
                this.accountIds = this.$refs.elasticComputeCloudResourceSearchChild.accountIds;
                this.regions = this.$refs.elasticComputeCloudResourceSearchChild.regions;
                this.offeringType = this.$refs.elasticComputeCloudResourceSearchChild.offeringType;
                this.state = this.$refs.elasticComputeCloudResourceSearchChild.state;
                this.expiration = this.$refs.elasticComputeCloudResourceSearchChild.expiration;

                if (this.accountIds == "" || this.accountIds == null) {
                    this.$Message.warning("请选择账号", 5)
                    return;
                }
                if (this.regions == "" || this.regions == null) {
                    this.$Message.warning("请选择区域", 5)
                    return;
                }


                this.modal_loading = true
                this.$Message.loading({
                  duration: 0,
                  content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.reservedInstance.exportReservedInstances({
                   "initAccountType": 2,
                    "accountId": this.awsId,
                    "accountIds": this.accountIds,
                    "regions": this.regions,
                    "offeringType": this.offeringType,
                    "expiration": this.expiration,
                    "state": this.state
                })
                .then(res => {
                    let fileName = 'EC2预留实例.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    this.modal_loading = false;
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            }
        }
    }
</script>

<style scoped>
    .elasticComputeCloudResource-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        overflow: hidden;
        font-weight: 600;
    }
    .elasticComputeCloudResource-title>div:nth-child(1)
    {
        float:left;
    }
    .elasticComputeCloudResource-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .elasticComputeCloudResource-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/ec2/ElasticComputeCloudResource.vue